var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1759_15738)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.902 16.7999H15.4943C15.3718 16.7973 15.2501 16.8204 15.1371 16.8675C15.024 16.9147 14.922 16.985 14.8377 17.0738C14.7533 17.1627 14.6885 17.2682 14.6473 17.3836C14.6061 17.4989 14.5894 17.6216 14.5983 17.7438L15.1663 26.0956C15.2032 26.6204 15.4406 27.1108 15.8293 27.4653C16.218 27.8198 16.7283 28.0111 17.2542 27.9995L23.294 27.9275C23.8128 27.9202 24.3094 27.7162 24.6836 27.3569C25.0578 26.9976 25.2817 26.5096 25.31 25.9916L25.798 17.7358C25.8057 17.6143 25.7882 17.4925 25.7465 17.378C25.7047 17.2636 25.6397 17.1591 25.5555 17.0711C25.4712 16.9832 25.3697 16.9136 25.2572 16.8669C25.1447 16.8202 25.0238 16.7974 24.902 16.7999ZM21.3581 24.2396H19.0382C18.879 24.2396 18.7264 24.1764 18.6139 24.0639C18.5014 23.9514 18.4382 23.7988 18.4382 23.6396C18.4382 23.4805 18.5014 23.3279 18.6139 23.2154C18.7264 23.1029 18.879 23.0397 19.0382 23.0397H21.3581C21.5172 23.0397 21.6698 23.1029 21.7824 23.2154C21.8949 23.3279 21.9581 23.4805 21.9581 23.6396C21.9581 23.7988 21.8949 23.9514 21.7824 24.0639C21.6698 24.1764 21.5172 24.2396 21.3581 24.2396ZM21.9821 21.2797H18.4142C18.2551 21.2797 18.1025 21.2165 17.9899 21.104C17.8774 20.9915 17.8142 20.8389 17.8142 20.6797C17.8142 20.5206 17.8774 20.368 17.9899 20.2555C18.1025 20.143 18.2551 20.0798 18.4142 20.0798H21.9821C22.1412 20.0798 22.2938 20.143 22.4063 20.2555C22.5189 20.368 22.5821 20.5206 22.5821 20.6797C22.5821 20.8389 22.5189 20.9915 22.4063 21.104C22.2938 21.2165 22.1412 21.2797 21.9821 21.2797ZM27.3979 15.6159C27.3742 15.7727 27.2894 15.9138 27.1619 16.0082C27.0345 16.1027 26.8749 16.1428 26.7179 16.1199C22.3997 15.5259 18.0205 15.5259 13.7023 16.1199H13.5983C13.4478 16.1195 13.303 16.0625 13.1925 15.9603C13.082 15.8581 13.014 15.7181 13.0019 15.5681C12.9899 15.418 13.0346 15.269 13.1273 15.1504C13.22 15.0318 13.3538 14.9524 13.5023 14.9279C13.6143 14.9279 14.9663 14.6959 17.0622 14.5599L17.3262 13.208C17.3931 12.867 17.5766 12.56 17.8452 12.3396C18.1138 12.1191 18.4507 11.9991 18.7982 12H21.6221C21.9714 12.0013 22.3094 12.1242 22.578 12.3475C22.8465 12.5709 23.029 12.8808 23.094 13.224L23.342 14.5679C24.478 14.6399 25.67 14.7519 26.8859 14.9359C26.9643 14.9467 27.0398 14.9729 27.108 15.013C27.1762 15.053 27.2358 15.1062 27.2834 15.1694C27.331 15.2326 27.3656 15.3046 27.3852 15.3812C27.4049 15.4578 27.4092 15.5376 27.3979 15.6159Z",
    fill: "#FF3D00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1759_15738",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1759_15738"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1759_15738",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteImg);
export default __webpack_public_path__ + "static/media/delete-img.aaed88139fb27b3fc59042e4535c5a89.svg";
export { ForwardRef as ReactComponent };